module.exports = __webpack_public_path__ + "img/17.698dc489.jpg";